import React, { useEffect, useState } from "react";
import "../../../discussions.css";
import PublicChat from "../PublicChat";
import { db, auth } from "../../../firebase";

const Discussions = ({ puid }) => {
  const ref = React.createRef();
  const postid = JSON.parse(localStorage.getItem("postid"))["postid"];
  const [chatnum, setchatNum] = useState(0);
  const View = () => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    var k = 0;
    db.collection("posts")
      .doc(postid)
      .collection("conversations")
      .onSnapshot((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const chatid = doc.id;
          k = k + 1;
        });
        setchatNum(k);
        k = 0;
      });
  }, [postid]);
  return (
    <>
      <div className="text" ref={ref}>
        <p style={{ fontSize: "20px" }}>Discussions</p>
        <div className="main">
          <p
            style={{
              fontSize: "15px",
              fontWeight: "500",
              margin: "13px 15px",
              width: "fit-content"
            }}
          >
            {chatnum}&nbsp;Chats
          </p>
          <hr style={{ margin: 0 }} />
          <PublicChat puid={puid} View={View} />
          {/* <div className="chatarea">
          <PublicChat puid={puid} View={View} />
        </div> */}
        </div>

        {/* <div className="ad1">
          <script
            async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4510551333259158"
            crossorigin="anonymous"
          ></script>
          <ins
            class="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client="ca-pub-4510551333259158"
            data-ad-slot="2158945935"
            data-ad-format="auto"
            data-full-width-responsive="true"
          ></ins>
          <script>(adsbygoogle = window.adsbygoogle || []).push({ });</script>
        </div>
        <div className="ad2">
          <script
            async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4510551333259158"
            crossorigin="anonymous"
          ></script>
          <ins
            class="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client="ca-pub-4510551333259158"
            data-ad-slot="2158945935"
            data-ad-format="auto"
            data-full-width-responsive="true"
          ></ins>
          <script>(adsbygoogle = window.adsbygoogle || []).push({ });</script>
        </div> */}

      </div>
    </>

  );
};

export default Discussions;
